/*global define*/
define(function () {
    'use strict';

    /**
     *
     * @param {RestWrapper} RestWrapper
     * @param {Configuration} Configuration
     * @param {AdminDescription} AdminDescription
     * @param {PromisesResolver} PromisesResolver
     *
     * @returns {ReadQueries}
     * @constructor
     */
    function WriteQueries(RestWrapper, Configuration, AdminDescription, PromisesResolver) {
        return AdminDescription.getWriteQueries(RestWrapper, PromisesResolver, Configuration())
    }

    WriteQueries.$inject = ['RestWrapper', 'NgAdminConfiguration', 'AdminDescription', 'PromisesResolver'];

    return WriteQueries;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Crud/repository/WriteQueries.js
 **/